import { Component, Input, model, ModelSignal } from '@angular/core';
import { JureCdc } from 'src/app/data/commission/models/jure-cdc.model';
import { JureSynthese } from 'src/app/data/commission/models/jure-synthese.model';
import { DatePipe } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { Column } from '../../../../../../../shared/models/column.model';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-detail-synthese',
    templateUrl: './detail-synthese.component.html',
    styleUrls: ['./detail-synthese.component.scss'],
    imports: [DatePipe, Dialog, TranslateModule, TableModule],
    standalone: true
})
export class DetailSyntheseComponent {
    /**
     * Signal modal visible
     */
    visible: ModelSignal<boolean> = model(false);

    /**
     * Détail des jurés
     */
    @Input() detailJures: JureCdc[];

    /**
     * Synthèse du juré
     */
    @Input() jure: JureSynthese;

    /**
     * Colonnes dynamiques
     */
    columns: Column[] = [
        { field: 'numeroCommission', label: 'page.commissions.synthese-jure.modals.numeroCommission' },
        { field: 'dateCommission', label: 'page.commissions.synthese-jure.modals.dateCommission' },
        { field: 'statut', label: 'page.commissions.synthese-jure.modals.statut' },
        { field: 'college', label: 'page.commissions.synthese-jure.modals.college' },
        { field: 'cdcs', label: 'page.commissions.synthese-jure.modals.cdcs' }
    ];
}
